import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BriefcaseIcon, GraduationCapIcon, LightbulbIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function AboutPreview() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    t
  } = useLanguage();
  const pillars = [{
    icon: BriefcaseIcon,
    title: t('about.p1.title'),
    desc: t('about.p1.desc')
  }, {
    icon: GraduationCapIcon,
    title: t('about.p2.title'),
    desc: t('about.p2.desc')
  }, {
    icon: LightbulbIcon,
    title: t('about.p3.title'),
    desc: t('about.p3.desc')
  }];
  return <section id="about" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-3">
      <div className="relative z-10 mx-auto max-w-7xl" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12 sm:mb-16 text-center max-w-3xl mx-auto" data-id="element-5">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{
          color: 'var(--text-primary)'
        }} data-id="element-6">
            {t('about.title')}
          </h2>
          <p className="text-lg" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-7">
            {t('about.desc')}
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-3" data-id="element-8">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1 + index * 0.1
        }} data-id="element-9">
              <div className="h-full rounded-3xl border p-6 sm:p-8 flex flex-col relative transition-all hover:-translate-y-1 hover:shadow-lg" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-secondary)'
          }} data-id="element-10">
                <div className="flex items-center gap-4 mb-6" data-id="element-11">
                  <div className="p-3.5 rounded-2xl flex-shrink-0" style={{
                backgroundColor: 'var(--bg-tertiary)'
              }} data-id="element-12">
                    <pillar.icon className="w-6 h-6" style={{
                  color: 'var(--accent)'
                }} data-id="element-13" />
                  </div>
                  <h3 className="text-xl font-bold" style={{
                color: 'var(--text-primary)'
              }} data-id="element-14">
                    {pillar.title}
                  </h3>
                </div>
                <p className="text-base leading-relaxed flex-1" style={{
              color: 'var(--text-secondary)'
            }} data-id="element-15">
                  {pillar.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}